const LocationReviewsData = [
  {
    "customer": "Michael S.",
    "review": "Exceptional service! The team was punctual, friendly, and thoroughly cleaned my chimney. I noticed better airflow right away.",
    "service": "Chimney Cleaning"
  },
  {
    "customer": "Jessica T.",
    "review": "Master Air Duct exceeded my expectations. They cleaned the fireplace and chimney, and I can already feel the difference. Highly recommend!",
    "service": "Chimney Cleaning"
  },
  {
    "customer": "Emily R.",
    "review": "Great experience from start to finish. The techs were knowledgeable, explained the process, and left everything spotless.",
    "service": "Chimney Cleaning"
  },
  {
    "customer": "Anthony J.",
    "review": "Efficient, professional, and reliable. I appreciate how the team paid attention to every detail. My fireplace is working much better now.",
    "service": "Chimney Cleaning"
  },
  {
    "customer": "Robert K.",
    "review": "Quick response time and thorough chimney cleaning. I feel much safer using my fireplace now, thanks to Master Air Duct.",
    "service": "Chimney Cleaning"
  },
  {
    "customer": "Sarah P.",
    "review": "They did an amazing job with my chimney sweep. The team was respectful of my home and got the job done quickly.",
    "service": "Chimney Sweeping"
  },
  {
    "customer": "Lisa M.",
    "review": "Very impressed with the quality of service. The technicians were polite and took care of everything efficiently.",
    "service": "Chimney Sweeping"
  },
  {
    "customer": "Kevin H.",
    "review": "Master Air Duct provided excellent service, and I noticed my fireplace working more efficiently after the cleaning.",
    "service": "Chimney Sweeping"
  },
  {
    "customer": "Diana F.",
    "review": "This was my first time using them, and I’ll definitely call again. Great value and fantastic results.",
    "service": "Chimney Sweeping"
  },
  {
    "customer": "Eric W.",
    "review": "The technicians were professional and completed the cleaning quickly. My chimney is now free of creosote buildup!",
    "service": "Chimney Sweeping"
  },
  {
    "customer": "Samantha L.",
    "review": "The team did a fantastic job inspecting our chimney. They provided a detailed report and explained everything clearly.",
    "service": "Chimney Inspection"
  },
  {
    "customer": "Tom C.",
    "review": "Master Air Duct saved us from a potential hazard by thoroughly inspecting and cleaning our chimney. Very grateful!",
    "service": "Chimney Inspection"
  },
  {
    "customer": "Olivia N.",
    "review": "Highly recommend their chimney inspection service. They arrived on time and provided peace of mind with their thorough check.",
    "service": "Chimney Inspection"
  },
  {
    "customer": "Jason B.",
    "review": "I could tell they knew exactly what they were doing. They identified and fixed a small issue before it became a major problem.",
    "service": "Chimney Inspection"
  },
  {
    "customer": "Maria S.",
    "review": "Master Air Duct did an amazing job inspecting and cleaning our chimney. I never realized how much buildup could accumulate over time!",
    "service": "Chimney Inspection"
  },
  {
    "customer": "Peter V.",
    "review": "Quick, efficient, and friendly service. I’ll be scheduling regular chimney inspections with them.",
    "service": "Chimney Inspection"
  },
  {
    "customer": "Vanessa D.",
    "review": "Outstanding service! The techs were knowledgeable and explained the importance of regular chimney maintenance.",
    "service": "Chimney Inspection"
  },
  {
    "customer": "Ben A.",
    "review": "I had a significant creosote buildup in my chimney, but Master Air Duct handled it well. Great job!",
    "service": "Chimney Cleaning"
  },
  {
    "customer": "Amy G.",
    "review": "They were able to schedule me quickly and did a thorough job. I appreciate their attention to safety.",
    "service": "Chimney Inspection"
  },
  {
    "customer": "Rachel K.",
    "review": "Very pleased with the chimney sweep service. The team was professional, and I can already tell the difference in performance.",
    "service": "Chimney Sweeping"
  },
  {
    "customer": "Alex P.",
    "review": "The team found and fixed a crack in my chimney that I didn't even know existed. Great service!",
    "service": "Chimney Repair"
  },
  {
    "customer": "Brandon L.",
    "review": "Had a repair done on my chimney, and they did an excellent job. It’s now safe and fully functional.",
    "service": "Chimney Repair"
  },
  {
    "customer": "Nina J.",
    "review": "They quickly identified and fixed the issue with my chimney cap. I’m very happy with the results.",
    "service": "Chimney Repair"
  },
  {
    "customer": "Trevor M.",
    "review": "Master Air Duct repaired a small crack in my chimney crown. It’s working much better now, and I’m very satisfied.",
    "service": "Chimney Repair"
  },
  {
    "customer": "Katie W.",
    "review": "The team was able to repair my damaged chimney and improve its structure. Highly recommend.",
    "service": "Chimney Repair"
  },
  {
    "customer": "Chris B.",
    "review": "The technicians did a thorough inspection and fixed some issues I wasn't aware of. Great job!",
    "service": "Chimney Repair"
  },
  {
    "customer": "Megan R.",
    "review": "Very satisfied with their service. They repaired my chimney and made sure everything was safe for use.",
    "service": "Chimney Repair"
  },
  {
    "customer": "Danny H.",
    "review": "The repair work on my chimney was quick, and the results were excellent. I appreciate their professionalism.",
    "service": "Chimney Repair"
  },
  {
    "customer": "Lauren T.",
    "review": "Master Air Duct did a wonderful job repairing our chimney. The airflow is now consistent, and we feel safer using it.",
    "service": "Chimney Repair"
  },
  {
    "customer": "Rick A.",
    "review": "They were able to repair the issues in our chimney promptly. I’m very pleased with their service.",
    "service": "Chimney Repair"
  },
  {
    "customer": "Ashley E.",
    "review": "The techs were professional and repaired the chimney efficiently. Our home feels more comfortable now.",
    "service": "Chimney Repair"
  },
  {
    "customer": "Monica G.",
    "review": "The team was able to fix a leak in my chimney that was affecting safety. Great job!",
    "service": "Chimney Repair"
  },
  {
    "customer": "Hank F.",
    "review": "I was impressed by their thorough inspection and repair work. They really know what they're doing.",
    "service": "Chimney Repair"
  },
  {
    "customer": "Jasmine K.",
    "review": "Master Air Duct repaired our chimney and also cleaned it. The service was fantastic, and the results are noticeable.",
    "service": "Chimney Repair"
  }
];

export default LocationReviewsData;
